import Glide from '@glidejs/glide'


class ImageSlider {
      constructor(element) {
            this.glide = null;
            this.element = element;
            this.init();
      }

      init() {   
            this.slider();
            
            window.onload= function(){
                  var glide = this.element.querySelector(".image .glide__slides");
                  var slides =  Array.from(glide.querySelectorAll(".image .glide__slide--clone"));
                  var arrows = this.element.querySelector(".image .glide__arrows");

                  if(slides.length <= 2) {
                        arrows.classList.add("hide-arrows");
                  
                        slides.forEach((slide) => {
                              slide.classList.add("two-slides");
                        });

                  } else {
                        arrows.classList.remove("hide-arrows");
                  }

            }.bind(this);    

      }

      slider () {
            this.glide = new Glide(this.element, {
                  type: 'carousel',
                  perView: 2,
                  gap: 25,
                  peek: {
                        before: 60,
                        after: 60
                  },
                  bound: true,
                  breakpoints: {
                        800: {
                              perView: 1,
                              gap: 10,
                              peek: 30,
                        }
                  }
            }).mount();
      }
}

export default ImageSlider;